import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodos() {
        return axiosJwt.get(`${api}/controleacesso/fornecedores/perfisacesso`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
